import { combineReducers } from 'redux';
import aiSurveyMatchReducer from './aiSurveyMatchGridCreate';

const defaultState = {
    filters: []
};

export function aiMatchReducer (state = defaultState, action: any) {
    switch (action.type) {
        default: return state;
    }
}

export default combineReducers({
    aiSurveyMatchGrid: aiSurveyMatchReducer,
    aiMatching: aiMatchReducer,
})
